<!-- 主页未登录 -->
<template>
  <div class="home-component-container">
    <van-image
      width="100%"
      fit="contain"
      class="top-img"
      :src="homeImg"
    />
    <van-image
      width="100%"
      fit="contain"
      class="top-img-level"
      :src="home2Img"
    />
  </div>
</template>

<script>
import homeImg from '@/assets/images/home/home.png'
import home2Img from '@/assets/images/home/home2.jpg'
export default {
  name: 'no-auth-home',
  components: { },
  props: {
    propsData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mounted() {

  },
  data() {
    return {
      rewardData: [],
      homeImg,
      home2Img
    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
  .top-img{
    margin-top: -88px;
  }
  .home-component-container {
    padding: 0;
    padding-bottom: 135px;
  }
</style>
